__turbopack_context__.v({
  "card": "CourseInformation-module__wuTQYW__card",
  "expandedContent": "CourseInformation-module__wuTQYW__expandedContent",
  "header": "CourseInformation-module__wuTQYW__header",
  "separator": "CourseInformation-module__wuTQYW__separator",
  "subtitle": "CourseInformation-module__wuTQYW__subtitle",
  "title": "CourseInformation-module__wuTQYW__title",
  "toggle": "CourseInformation-module__wuTQYW__toggle",
});
